var exports = {
  "Zd": "AddFriendForm.module__form___TzhNTT",
  "kL": "AddFriendForm.module__container___TzhNTT",
  "QX": "AddFriendForm.module__containerDesktop___TzhNTT",
  "hF": "AddFriendForm.module__input___TzhNTT",
  "Rq": "AddFriendForm.module__inputDesktop___TzhNTT",
  "Xu": "AddFriendForm.module__inputError___TzhNTT",
  "x6": "AddFriendForm.module__button___TzhNTT",
  "oR": "AddFriendForm.module__inlineButton___TzhNTT",
  "gJ": "AddFriendForm.module__errorMessage___TzhNTT",
  "Jl": "AddFriendForm.module__successMessage___TzhNTT",
};

module.exports = exports;
